// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import WarrantyApprovePage from "./WarrantyApprovePage";
import Dashboard from "./Dashboard";
import CustomerForm from "./CustomerForm";
import ServiceRequestForm from "./ServiceRequestForm";
import WarrantySalesAdminPage from "./WarrantySalesAdminPage";
import WarrantyLogisticsPage from "./WarrantyLogisticsPage";
import WarrantyFinalizePage from "./WarrantyFinalizePage";
import WarrantyList from "./WarrantyList";



function ProtectedApp() {
  return (
    <Authenticator>
      {({ signOut, user }) => <Dashboard user={user} signOut={signOut} />}
    </Authenticator>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ✅ Public pages (no login) */}
        <Route path="/customer" element={<CustomerForm />} />
        <Route path="/service-request" element={<ServiceRequestForm />} />
        <Route path="/warranty_approve" element={<WarrantyApprovePage />} />
        <Route path="/warranty_salesadmin" element={<WarrantySalesAdminPage />} />
        <Route path="/warranty_logistics" element={<WarrantyLogisticsPage />} />
        <Route path="/warranty_finalize" element={<WarrantyFinalizePage />} />
        <Route path="/warranty-list" element={<WarrantyList />} />
        {/* ✅ Everything else is protected */}
        <Route path="/*" element={<ProtectedApp />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
